export type ColorSchemeId = 'green' | 'red' | 'blue' | 'orange';

export interface ColorSchemeDefinition {
    id: ColorSchemeId;
    name: string;
    colors: {
        light: {
            primary: string;
            secondary: string;
        };
        dark: {
            primary: string;
            secondary: string;
        };
    };
    gradient?: {
        light: { from: string; to: string };
        dark: { from: string; to: string };
    };
}

export const COLOR_SCHEMES: Record<ColorSchemeId, ColorSchemeDefinition> = {
    green: {
        id: 'green',
        name: 'Zelena',
        colors: {
            light: {
                primary: '#31a853',
                secondary: '#f50057',
            },
            dark: {
                primary: '#4caf50',
                secondary: '#f48fb1',
            },
        },
        gradient: {
            light: { from: '#43e97b', to: '#38f9d7' },
            dark: { from: '#2e7d32', to: '#00695c' },
        },
    },
    red: {
        id: 'red',
        name: 'Hasicska cervena',
        colors: {
            light: {
                primary: '#C62828',
                secondary: '#1565C0',
            },
            dark: {
                primary: '#E53935',
                secondary: '#42a5f5',
            },
        },
        gradient: {
            light: { from: '#ff6b6b', to: '#ee5a24' },
            dark: { from: '#b71c1c', to: '#880e4f' },
        },
    },
    blue: {
        id: 'blue',
        name: 'Zachranne slozky',
        colors: {
            light: {
                primary: '#1565C0',
                secondary: '#C62828',
            },
            dark: {
                primary: '#42a5f5',
                secondary: '#E53935',
            },
        },
        gradient: {
            light: { from: '#667eea', to: '#764ba2' },
            dark: { from: '#0d47a1', to: '#311b92' },
        },
    },
    orange: {
        id: 'orange',
        name: 'Vystraha',
        colors: {
            light: {
                primary: '#e65100',
                secondary: '#00897b',
            },
            dark: {
                primary: '#ff9800',
                secondary: '#4db6ac',
            },
        },
        gradient: {
            light: { from: '#f7971e', to: '#ffd200' },
            dark: { from: '#e65100', to: '#bf360c' },
        },
    },
};

export const DEFAULT_COLOR_SCHEME: ColorSchemeId = 'green';

export const getColorScheme = (id: ColorSchemeId | string): ColorSchemeDefinition => {
    return COLOR_SCHEMES[id as ColorSchemeId] || COLOR_SCHEMES[DEFAULT_COLOR_SCHEME];
};
